import React from 'react';

import PageTitle from '../components/pagetitle/PageTitle';
import Faq3 from '../components/faqs/Faq3';
import dataFaqs from '../assets/fake-data/data-faq';
import Footer from '../components/footer/Footer';


import img from '../assets/images/layouts/touch.png'

function Contact(props) {
    return (
        <div className='wrapper'>

            <PageTitle title='Contact' />

            <section className="touch">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text center">
                                <h6 className="sub-heading"><span>Get in Touch!</span></h6>
                                <h3 className="heading">Let’s Start Working <br />
                                    Together
                                    </h3>
                            </div>
                            <div className="touch__main">
                                

                                <form action="#" className="form-box">
                                    <div className="row">
                                        <div className="col">
                                            <label >Your name</label>
                                        <input type="text" className="form-control" />
                                        </div>
                                        <div className="col">
                                            <label >Your email</label>
                                        <input type="email" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <label >Your phone</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                        <div className="col">
                                            <label >Subject</label>
                                            <select className="form-control">
                                                <option>Select</option>
                                                <option>Select</option>
                                                <option>Select</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <label >Message</label>
                                            <textarea name="mess" id="mess" cols="30" rows="10"></textarea>
                                        </div>
            
                                    </div>
                                    <div className="row mb-0">
                                        <div className="col">
                                            <button className="action-btn"><span>Send Now</span></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="map">
                <div className="container">
                    <div className="row">
                        <div className="map__main">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d86077.66255184308!2d-122.40402224079803!3d47.60810999586645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54906ab3f905c4b1%3A0x96bf575ff75ab1aa!2s411%20University%20St%2C%20Seattle%2C%20WA%2098101%2C%20Hoa%20K%E1%BB%B3!5e0!3m2!1svi!2s!4v1584084043716!5m2!1svi!2s" title='map' height="600" allowFullScreen="" aria-hidden="false" tabIndex="0" />
                        </div>
                    </div>
                </div>
            </div>

            <Faq3 data={dataFaqs} />

            <Footer />


            
        </div>
    );
}

export default Contact;